export default {
  'SimpleDatePicker.allTime': 'All time',
  'SimpleDatePicker.lastWeek': 'Last week',
  'SimpleDatePicker.lastMonth': 'Last month',
}
